import { useMemo } from "react";
import { showDenominations } from "../utils";
import colors from "../../../../theme/Colours";
import DashboardListCard from "../../../../common/dashboard/DashboardListCard";

export default function TopClientsByRevenue({
  data,
  hideGrowthIndicator = false,
}: {
  data: {
    key: string;
    name: string;
    details: {
      period: string;
      name: string;
      values: {
        client_name: string;
        pincode: string;
        revenue: string;
        previous_month_percent?: string;
      }[];
    }[];
  };
  hideGrowthIndicator?: boolean;
}) {
  const items = useMemo(() => {
    if (!data?.details?.length) return [];
    const current = data.details[0];

    return current.values.map((client, index) => {
      const isTopClient = index === 0;
      let helperText = "";
      let isPositive: boolean | null = null;

      if (!hideGrowthIndicator && client.previous_month_percent) {
        const raw = parseFloat(String(client.previous_month_percent));
        if (Number.isFinite(raw)) {
          if (raw > 0) isPositive = true;
          else if (raw < 0) isPositive = false;
          helperText = client.previous_month_percent;
        }
      }

      return {
        title: client.client_name,
        subtitle: client.pincode,
        rightTop: `₹${showDenominations(Number(client.revenue))}`,
        rightBottom: "",
        helperText,
        isPositive,
        backgroundColor: isTopClient
          ? colors.salesAnalyticsCardTopClientBg
          : colors.greyBorder,
      };
    });
  }, [data, hideGrowthIndicator]);

  return <DashboardListCard title={data?.name} items={items} />;
}
